import { useSelector } from 'react-redux';
import { getNotifications, getUnreadNotificationsCount } from '../../../selectors/notifications';

const useNotifications = () => {
  const notifications = useSelector(getNotifications);
  const unreadNotificationsCount = useSelector(getUnreadNotificationsCount);
  return { notifications, unreadNotificationsCount };
};

export default useNotifications;
